import styled from 'styled-components';
import { useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import { Navigation, Autoplay } from 'swiper/modules';
import { SwiperImgUrl } from '../components/list';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Introduction2 = () => {
    useEffect(() => {
        AOS.init({
            duration: 800,
            offset: 0,
        });
    }, []);

    return (
        <Wrap>
            <Con1 className='con'>
                <h1 className='tb tac' data-aos="fade" data-aos-delay="300">더 <span className='tb inblock'>새로운</span><br/>증명서 시스템</h1>
                <SwiperBox className='rel' data-aos="fade-up" data-aos-delay="700">
                    <Swiper
                        modules={[Navigation, Autoplay]}
                        breakpoints={{
                            360: { slidesPerView: 1.4, spaceBetween: 24 },
                            501: { slidesPerView: 2, spaceBetween: 24 },
                            767: { slidesPerView: 3, spaceBetween: 24 },
                            1201: { slidesPerView: 4, spaceBetween: 24 },
                            1920: { slidesPerView: 5, spaceBetween: 24 }, 
                        }}
                        loop={true}
                        navigation={{ prevEl: '.swiper-button-prev-custom', nextEl: '.swiper-button-next-custom' }}
                        autoplay={{ delay: 3000, disableOnInteraction: false }}
                    >
                        {SwiperImgUrl.map(
                            (item, index) => (
                                <SwiperSlide key={index}>
                                    <span className="img-box">
                                        <img src={item.imgUrl} alt="" />
                                    </span>
                                </SwiperSlide>
                            )
                        )}
                        {SwiperImgUrl.map(
                            (item, index) => (
                                <SwiperSlide key={index + SwiperImgUrl.length}>
                                    <span className="img-box">
                                        <img src={item.imgUrl} alt="" />
                                    </span>
                                </SwiperSlide>
                            )
                        )}
                    </Swiper>
                    <div className='swiper-button-prev-custom swiper-button-custom abs img-box y-middle'>
                        <img src="./img/arrow_prev_282828.svg" alt="" />
                    </div>
                    <div className='swiper-button-next-custom swiper-button-custom abs img-box y-middle'>
                        <img src="./img/arrow_next_282828.svg" alt="" />
                    </div>
                </SwiperBox>
            </Con1>
            <Con2 className='con flex aic jcsb'>
                <LeftBox data-aos="fade-right" data-aos-delay="300">
                    <span className="img-box">
                        <img src="./img/introduction2_img_1.png" alt="" />
                    </span>
                </LeftBox>
                <RightBox data-aos="fade-left" data-aos-delay="700">
                    <div className="text-box">
                        <h2 className='tb'>한국건축물안전협회</h2>
                        <p className='lh140'>한국 건축물 안전 협회는 지역사회, 사회적 취약시설 건축물 등 건축물 안전과 관리를 위한 조사 및 연구활동을 하고, 표준화 기준 마련 및 시스템 구축 등의 관리 방안을 토대로 사회적 취약계층에 대한 지원사업을 수행함으로써 건축물 안전 확보와 공익에 기여하고자 합니다.</p>
                    </div>
                </RightBox>
            </Con2>
        </Wrap>
    );
}

export default Introduction2;

const Wrap = styled.div`
    width: 100%;
    background-color: #fff;
    box-sizing: border-box;
    padding: 100px 0;
    @media (max-width: 1400px) {
        padding: 7.1428vw 0;
    }
    @media (max-width: 767px) {
        padding: 50px 0;
    }
`
const Con1 = styled.div`
    padding: 0 28px;
    @media (max-width: 1550px) {
        padding: 0 52px;
    }
    @media (max-width: 1400px) {
        padding: 0 92px;
    }
    @media (max-width: 1024px) {
        padding: 0 40px;
    }
    @media (max-width: 767px) {
        padding: 0 16px;
    }
    @media (max-width: 500px) {
        padding: 0 0 0 0;
    }

    > h1 {
        font-size: 55px;
        line-height: 60px;
        color: #282828;
        @media (max-width: 1400px) {
            font-size: 3.9285vw;
            line-height: 4.2857vw;
        }
        @media (max-width: 767px) {
            font-size: 30px;
            line-height: 40px;
        }
        
        > span {
            line-height: 60px;
            color: ${props => props.theme.mainColor1};
            @media (max-width: 1400px) {
                line-height: 4.2857vw;
            }
            @media (max-width: 767px) {
                line-height: 40px;
            }
        }
    }
`
const SwiperBox = styled.div`
    > .swiper {
        z-index: 1;
        box-sizing: border-box;
        padding: 40px 12px;
        @media (max-width: 1400px) {
            padding: 2.8571vw 0.8571vw;
        }
        @media (max-width: 767px) {
            padding: 24px 12px;
        }

        .swiper-slide {
            border-radius: 20px;
            box-shadow: 0px 4px 14px 0px rgba(161, 161, 161, 0.25);
            overflow: hidden;
            @media (max-width: 1400px) {
                border-radius: 1.4285vw;
                box-shadow: 0px 0.2857vw 0.7142vw 0px rgba(161, 161, 161, 0.25);
            }
            @media (max-width: 767px) {
                border-radius: 20px;
                box-shadow: 0px 4px 14px 0px rgba(161, 161, 161, 0.25);
            }
        }
    }

    > .swiper-button-custom {
        width: 40px;
        z-index: 2;
        cursor: pointer;
        &.swiper-button-prev-custom {
            left: -52px;
        }
        &.swiper-button-next-custom {
            right: -52px;
        }
        @media (max-width: 1400px) {
            width: 2.8571vw;
            &.swiper-button-prev-custom {
                left: -3.7142vw;
            }
            &.swiper-button-next-custom {
                right: -3.7142vw;
            }
        }
        @media (max-width: 767px) {
            width: 32px;
            &.swiper-button-prev-custom {
                left: -16px;
            }
            &.swiper-button-next-custom {
                right: -16px;
            }
        }
        @media (max-width: 500px) {
            width: 32px;
            &.swiper-button-prev-custom {
                left: 0;
            }
            &.swiper-button-next-custom {
                right: 0;
            }
        }
    } 

`

const Con2 = styled.div`
    margin-top: 60px;
    gap: 126px;
    @media (max-width: 1400px) {
        margin-top: 4.2857vw;
        gap: 9vw;
    }
    @media (max-width: 767px) {
        margin-top: 50px;
        gap: 24px;
        flex-direction: column;
    }
`
const LeftBox = styled.div`
    > .img-box {
        width: 514px;
        @media (max-width: 1400px) {
            width: 36.7142vw;
        }
        @media (max-width: 767px) {
            width: 75%;
        }
    }
`
const RightBox = styled.div`
    width: calc(100% - 640px);
    @media (max-width: 1400px) {
        width: calc(100% - 45.7142vw);
    }
    @media (max-width: 767px) {
        width: 100%;
    }

    > .text-box {
        width: 100%;

        > h2 {
            font-size: 36px;
            line-height: 48px;
            color: #740B25;
            @media (max-width: 1400px) {
                font-size: 2.5714vw;
                line-height: 3.4285vw;
            }
            @media (max-width: 767px) {
                font-size: 24px;
                line-height: 32px;
                text-align: center;
            }
        }

        > p {
            margin-top: 24px;
            font-size: 20px;
            color: #282828;
            @media (max-width: 1400px) {
                margin-top: 1.7142vw;
                font-size: 1.4285vw;
            }
            @media (max-width: 767px) {
                margin-top: 24px;
                font-size: 16px;
                line-height: 24px;
                text-align: center;
            }
        }
    }
`